module.exports = "pegasus/assets/theme4/medium/6.jpg";